import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text } from '../../Text/Text';
import { Toggle } from '../../Toggle/Toggle';
import { Box } from '../../layout/Box';
import { FlexContainer } from '../../layout/FlexContainer';
import { getInputTextDecorators } from '../getInputTextDecorators';
import { useInputTooltip } from '../useInputTooltip';
import { ToggleInputRow } from './ToggleInputRow';
export const ToggleInput = ({ tooltip, tooltipTabIndex, label, caption, updated = false, error = false, warning = false, readOnly = false, togglePosition = 'right', testId, ...props }) => {
    const { captionColor, captionText, tooltipIconColor, textColor } = getInputTextDecorators({
        error,
        updated,
        warning,
        caption,
        readOnly,
        isFocused: false,
    });
    const labelTestId = `${testId}-label`;
    const captionTestId = `${testId}-caption`;
    const tooltipElement = useInputTooltip({
        tooltip,
        tooltipTabIndex,
        tooltipIconColor,
    });
    const toggleElement = (_jsx(Box, { shrink: 0, children: _jsx(Toggle, { disabled: readOnly, testId: testId, ...props }) }));
    const shouldShowLabel = label !== undefined;
    const maybeLabelElement = shouldShowLabel ? (_jsx(Text, { variant: 'b2', testId: labelTestId, color: textColor, children: label })) : null;
    const maybeCaption = captionText ? (_jsx(Box, { children: _jsx(Text, { variant: 'b3', color: captionColor, testId: captionTestId, children: captionText }) })) : null;
    return (_jsxs(FlexContainer, { gap: '1/4', verticalAlign: 'center', direction: 'column', children: [_jsx(ToggleInputRow, { togglePosition: togglePosition, toggleElement: toggleElement, labelElement: maybeLabelElement, tooltipElement: tooltipElement }), maybeCaption] }));
};
